module.exports = __webpack_public_path__ + "static/media/Agenda6.eb7f918a.png";


//////////////////
// WEBPACK FOOTER
// ./src/imagens/Agenda/Agenda6.png
// module id = 1971
// module chunks = 0